<template>
  <div class="msg-template page-box">
    <div class="content-header top-line">
      <div class="m-input-outer">
        <el-input
          placeholder="标题"
          class="input-title box-item"
          style="width: 100%"
          v-model="title"
          clearable
        ></el-input>
      </div>
      <el-input
        placeholder="标题"
        class="input-title hidden-xs-only"
        style="width: 150px"
        v-model="title"
        clearable
      ></el-input>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <vs-button
        v-if="isAuth('wx:spiderArticle:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle()"
      >批量删除</vs-button>
    </div>
    <div class="content-header header-bottom">
      <div class="header-left inner-flex">
        <vs-button
          class="btn box-item"
          :disabled="selected < 1"
          @click="mutilCopyHandle"
        >批量复制</vs-button>
        <vs-button
          class="btn box-item"
          @click="pushHandle"
        >推送消息</vs-button>
      </div>
      <div class="header-right inner-flex">
        <vs-button
          class="btn box-item big"
          @click="ayscHandle"
          v-loading="ayscTplLoading"
        >
          <icon-svg
            icon-class="tongbu"
            class="tongbu-icon"
          >
          </icon-svg>
          同步公众号模板
        </vs-button>
          <vs-button
            type="info"
            class="btn box-item big"
          >
            <a
              target="_blank"
              href="https://kf.qq.com/faq/170209E3InyI170209nIF7RJ.html"
            >
              <icon-svg
              icon-class="lianjie"
              class="tongbu-icon"
            >
            </icon-svg>
            模板管理指引
            </a>
          </vs-button>
      </div>
    </div>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              模板ID
            </vs-th>
            <vs-th>
              标题
            </vs-th>
            <vs-th>
              模板名称
            </vs-th>
            <vs-th>
              模板字段
            </vs-th>
            <vs-th>
              是否有效
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.templateId}}
              </vs-td>
              <vs-td>
                <a :href="tr.url">{{tr.title}}</a>
              </vs-td>
              <vs-td>
                {{tr.name}}
              </vs-td>
              <vs-td
                style="max-width: 300px;min-width: 200px;"
              >
                <span
                  class="rap-normal"
                >{{tr.content}}</span>
              </vs-td>
              <vs-td>
                <span
                  :style="getStyle(tr)"
                  class="self-tag">{{tr.status?"有效":"无效"}}</span>
              </vs-td>
              <vs-td
                style="width: 120px"
              >
                <el-button
                  v-if="isAuth('wx:templatemsglog:update')"
                  type="text"
                  @click.stop="configHandle(tr.id)">配置</el-button>
                <el-button
                  v-if="isAuth('wx:templatemsglog:delete')"
                  type="text"
                  class="delete-btn"
                  @click="deleteHandle(tr.id)">删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <push-msg-dialog
      ref="pushdialog"
      :dialog-show="pushDialogShow"
      @close="closePushDialog"
      @open-dialog="pushDialogShow = true"
      @send-success="sendSuccess"
    ></push-msg-dialog>
    <edit-msg-tpl-dialog
      ref="editdialog"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editSuccess"
    ></edit-msg-tpl-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editMsgTplDialog from "../../../components/wx/msg-template/editMsgTplDialog";
import pushMsgDialog from "../../../components/wx/msg-template/pushMsgDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteMsgTpl} from "../../../api/wx/msg-template";
export default {
  name: "index",
  components: {
    pushMsgDialog,
    editMsgTplDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      title: '',
      ayscTplLoading: false,
      pushDialogShow: false,
      editDialogShow: false,
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    beforeInit(){
      // 没有数据 todo
      this.url = '/wx/manage/msgTemplate/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order': 'desc'
      }
      if(this.title){
        this.params.title = this.title;
      }
      return true;
    },

    getContentType(row) {
      switch (row.contentType) {
        case 1:
          return '文本';
        case 2:
          return '图片';
        case 3:
          return '图文'
      }
    },
    addHandle(){
      this.addDialogShow = true;
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    async mutilCopyHandle(){
      //
      let loading;
      for (let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];
        loading=this.$loading({
          lock: true,
          text: "复制模板："+item.title,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        item.id = '';
        item.updateTime = new Date()
        item.name +='_COPY';
        await this.addMsgTemplate(item).catch(()=>loading.close())
        loading.close()
      }
      loading.close();
      this.searchHandle();
    },
    addMsgTemplate(msgTemplate){
      return new Promise((resolve, reject) => {
        this.$http({
          url: 'wx/manage/msgTemplate/save',
          method: 'post',
          data: msgTemplate,
        }).then(({ data }) => {
          if (data && data.code === 200) {
            resolve()
          } else {
            this.$message.error(data.msg)
            reject(data.msg)
          }
        }).catch(err=>reject(err))
      })
    },
    pushHandle(){
      //
      if(!this.selected.length){
        this.$message.error('请勾选消息');
        return;
      }

      this.$nextTick(() => {
        let dialog = this.$refs.pushdialog;
        dialog.$refs.outform.init(this.selected[0])
      })
    },
    sendSuccess(){
      this.pushDialogShow = false;
    },
    closePushDialog(){
      this.pushDialogShow = false;
    },
    ayscHandle(){
      //
      this.ayscTplLoading = true;
      this.$http({
        url: 'wx/manage/msgTemplate/syncWxTemplate',
        method: 'post',
      }).then((data) => {
        this.ayscTplLoading = false;
        if (data.code === 200) {
          this.$message({
            message: '同步完成',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.searchHandle()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      }).catch(()=>this.ayscTplLoading=false)
    },
    editHandle(row){
      this.formData = row;
      this.editDialogShow = true;
    },
    editSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.editDialogShow = false;
    },
    configHandle(id){
      setTimeout(() => {
        this.editDialogShow = true;
        let form = this.$refs.editdialog.$refs.outform;
        form.init(id);
      },200)
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteMsgTpl(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.msg-template {
  background-color: #f8f8f8;
  .content-header,
  .page-content {
    background-color: #ffffff;
  }
  .content-header {
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .top-line {
    margin-bottom: 20px;
  }
  .tongbu-icon {
    margin-right: 5px;
  }
  .header-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .inner-flex {
      display: flex;
      &.header-left {
        justify-content: start;
      }
      &.header-right {
        justify-content: end;
      }
    }
  }


  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
@media screen and (max-width: 768px){
  .msg-template {
    .box-item {
      /deep/ .vs-button-text {
        white-space: nowrap;
      }
      &.big {
        padding-left: 1rem!important;
        padding-right: 1rem!important;
      }
    }
  }
}
</style>
